import React from 'react';
import { NewTableStyledTd } from './HBNewTable.styles';

const NewTableCellList = ({
    columnDefinitions,
    item,
    isRowHovered,
    itemId,
    isRowExpanded,
    setIsRowExpanded
}) => {
    return columnDefinitions.map(cell => {
        const key = `${itemId} ${cell.title || cell.id}`;
        return (
            <NewTableStyledTd key={key}>
                {cell.renderCell(item, {
                    isRowHovered,
                    isRowExpanded,
                    setIsRowExpanded
                })}
            </NewTableStyledTd>
        );
    });
};

export default React.memo(NewTableCellList);
